import { Box, ListItem, ListItemButton } from '@mui/material'
import type { ReactNode } from 'react'
import { forwardRef } from 'react'

import searchResultRowSx from '~/components/search/searchResultRowSx'

export type QuickSearchListItemProps = {
  selected: boolean
  onSelect: () => void
  icon: ReactNode
  children: ReactNode
  action?: ReactNode
}

export const QuickSearchListItem = forwardRef<HTMLLIElement, QuickSearchListItemProps>(function QuickSearchListItem(
  { selected, onSelect, icon, children, action },
  ref
) {
  return (
    <ListItem ref={ref} disablePadding>
      <ListItemButton selected={selected} onClick={onSelect} sx={searchResultRowSx('&.Mui-selected')}>
        <Box sx={{ color: 'text.secondary', display: 'flex', alignItems: 'center' }}>{icon}</Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
        {action}
      </ListItemButton>
    </ListItem>
  )
})
